import React from "react";

function Privacy() {
  return (
    <>
      <div className="min-h-screen p-3 md:px-20 lg:px-32">
        <h1 className="text-3xl my-3 font-semibold text-green">
          Privacy Policy
        </h1>
        <p className="lg:text-xl md:text-2xl md:leading-8">
          This Privacy Policy describes Our policies and procedures on the collection, use, and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You. We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.
        </p>

        <h2 className="text-2xl my-3 font-semibold text-green">
          Interpretation and Definitions
        </h2>
        <p className="lg:text-xl md:text-2xl md:leading-8">
          <strong>Interpretation:</strong> The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or plural.
        </p>

        <h3 className="text-xl my-3 font-semibold text-green">Definitions:</h3>
        <ul className="list-disc ml-5">
          <li>
            <strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.
          </li>
          <li>
            <strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party.
          </li>
          <li>
            <strong>Company</strong> refers to Karnataka State Dept of SSLR Licensed Surveyors Welfare Development Association, NUM 578 Bhootanakatte Road Alanahalli Mysuru 570028.
          </li>
          <li>
            <strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website.
          </li>
          <li>
            <strong>Country</strong> refers to: Karnataka, India.
          </li>
          <li>
            <strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.
          </li>
          <li>
            <strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.
          </li>
          <li>
            <strong>Service</strong> refers to the Website, accessible from https://karnatakalswelfare.org/
          </li>
          <li>
            <strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service.
          </li>
        </ul>

        <h2 className="text-2xl my-3 font-semibold text-green">Collecting and Using Your Personal Data</h2>

        <h3 className="text-xl my-3 font-semibold text-green">Types of Data Collected</h3>
        <ul className="list-disc ml-5">
          <li>
            <strong>Personal Data:</strong> While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. This may include email address, first name and last name, phone number, address, and other relevant data.
          </li>
          <li>
            <strong>Usage Data:</strong> Usage Data is collected automatically when using the Service. This may include information such as Your Device's IP address, browser type, the pages You visit, time spent, unique device identifiers, and other diagnostic data.
          </li>
        </ul>

        <h3 className="text-xl my-3 font-semibold text-green">Tracking Technologies and Cookies</h3>
        <p className="lg:text-xl md:text-2xl md:leading-8">
          We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. These include both Session and Persistent Cookies. For more information, please visit our Cookies Policy.
        </p>

        <h2 className="text-2xl my-3 font-semibold text-green">Use of Your Personal Data</h2>
        <ul className="list-disc ml-5">
          <li>To provide and maintain our Service.</li>
          <li>To manage Your Account.</li>
          <li>To contact You with important updates and offers.</li>
          <li>For business transfers and restructuring.</li>
          <li>To improve our Service, products, and marketing strategies.</li>
        </ul>

        <h2 className="text-2xl my-3 font-semibold text-green">Disclosure of Your Personal Data</h2>
        <ul className="list-disc ml-5">
          <li>We may share Your personal information with Service Providers, Affiliates, business partners, or during business transfers.</li>
          <li>With Your consent, we may also disclose Your information for various purposes as mentioned in this Privacy Policy.</li>
        </ul>

        <h2 className="text-2xl my-3 font-semibold text-green">Security of Your Personal Data</h2>
        <p className="lg:text-xl md:text-2xl md:leading-8">
          While we strive to use commercially acceptable means to protect Your Personal Data, no method of transmission over the Internet or electronic storage is 100% secure. We cannot guarantee its absolute security.
        </p>

        <h2 className="text-2xl my-3 font-semibold text-green">Children's Privacy</h2>
        <p className="lg:text-xl md:text-2xl md:leading-8">
          Our Service does not address anyone under the age of 13. If we learn that we have collected Personal Data from anyone under the age of 13, we take steps to remove that information.
        </p>

        <h2 className="text-2xl my-3 font-semibold text-green">Changes to This Privacy Policy</h2>
        <p className="lg:text-xl md:text-2xl md:leading-8">
          We may update this Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date at the top of the page.
        </p>

        <h2 className="text-2xl my-3 font-semibold text-green">Contact Us</h2>
        <p className="lg:text-xl md:text-2xl md:leading-8">
          If you have any questions about this Privacy Policy, You can contact us:
        </p>
        <ul className="list-disc ml-5">
          <li>By email: karnatakalswelfareassociation@gmail.com</li>
          <li>By visiting this page on our website: https://karnatakalswelfare.org/</li>
          <li>By phone number: +91 72041 00471</li>
          <li>By mail: NUM 578 Bhootanakatte Road Alanahalli Mysuru 570028</li>
        </ul>
      </div>
    </>
  );
}

export default Privacy;
